@if ({ isEditing: isEditing$ | async, selectedRow: selectedRow$ | async }; as data) {
  @if (props.label) {
    <apm-section-title
      [title]="props.label | apmTranslate"
      [ngClass]="{ 'mt-5': !isFirst }"
      [alignContentEnd]="false"
      matTooltip="{{ canDebug ? field.key : '' }}"
    >
      @if (props.errorsResource?.length > 0) {
        <span class="ms-3"></span>
        <apm-icon
          class="me-2"
          size="sm"
          icon="i_alert_error"
          [isButton]="true"
          (iconClick)="showErrorMessages(props.errorsResource)"
        ></apm-icon>
      }
    </apm-section-title>
  }
  <table>
    @for (row of field.fieldGroup; track row.key) {
      <tr
        [ngClass]="{
          'cursor-pointer': true,
          'bg-selected-row': data.selectedRow === row.key,
          'bg-editable-row': props.editable && data.isEditing,
          'bg-certified-row--green': row.props?.flags === 1,
          'bg-certified-row--ligth-green': row.props?.flags === 3,
          'bg-certified-row--orange': row.props?.flags === 4,
        }"
        (click)="setSelectedRow($event, row.key)"
        matTooltip="{{ canDebug ? row.key : '' }}"
      >
        <td class="text bold td-label">
          @if (row.props?.label) {
            <span>{{ row.props?.label | apmTranslate }}</span>
          }
        </td>
        <td class="text-start td-uom">{{ row.props?.uom ?? '-' }}</td>
        @for (cell of row.fieldGroup; track cell.key) {
          <td class="text-start" [class.error-light]="cell.props?.hasError ?? false">
            <formly-field [field]="cell"></formly-field>
          </td>
        }
      </tr>
    }
  </table>
  @if (props.image) {
    <div class="d-flex justify-content-center mt-3">
      <img src="{{ props.image }}" />
    </div>
  }
}
